<ng-container *ngIf="copy() as client">
    <div class='fd-small-content-card margin-top-base background-message'>
        <div class="d-flex">
            <mat-icon class="warning-icon">warning
            </mat-icon>
            <p class=" message-not-found" [innerHTML]="client.body"></p>
        </div>
    </div>
</ng-container>